import React, { FC } from 'react';
import ConsultantScopedDashboard from './ConsultantScopedDashboard';

interface ClientDashboardProps {
    clientId: string;
    clientName: string;
}

const ClientDashboard: FC<ClientDashboardProps> = ( { clientId, clientName } ) => (
    <ConsultantScopedDashboard
        scope={ 'consultant' }
        params={ { clientId } }
        title={ clientName }
        pageStorageKey={ 'corval-consultant-page-dashboard-page-id' }
        gridIdentityKey={ clientId }
    />
);

export default ClientDashboard;
